// Cards height
export const GROUP_CARD_HEIGHT = 204
export const PREVIEW_GROUP_CARD_HEIGHT = 384
export const CATEGORY_CARD_HEIGHT = 157
export const ACTIVITY_CARD_HEIGHT = 417
export const PROFICIENCY_CARD_HEIGHT = 417
export const EVENTS_SCHEDULE_CARD_HEIGHT = 337
export const EVENT_CARD_HEIGHT = 417

// Card common components height
export const CARD_PREVIEW_HEIGHT = 180
export const CARD_TITLE_ROW_HEIGHT = 24
export const CARD_LABEL_HEIGHT = 30
export const CARD_INFO_HEIGHT = 25
export const CARD_FOOTER_HEIGHT = 26
